var loungeLocationPages = {
  'aberdeen-airport-lounges': 'Aberdeen airport lounges',
  'belfast-airport-lounges': 'Belfast airport lounges',
  'birmingham-airport-lounges': 'Birmingham airport lounges',
  'blackpool-airport-lounges': 'Blackpool airport lounges',
  'bristol-airport-lounges': 'Bristol airport lounges',
  'cardiff-airport-lounges': 'Cardiff airport lounges',
  'doncaster-airport-lounges': 'Doncaster airport lounges',
  'teesside-airport-lounges': 'Durham Tees airport lounges',
  'eastmidlands-airport-lounges': 'East Midlands airport lounges',
  'edinburgh-airport-lounges': 'Edinburgh airport lounges',
  'exeter-airport-lounges': 'Exeter airport lounges',
  'gatwick-airport-lounges': 'Gatwick lounges',
  'glasgow-airport-lounges': 'Glasgow airport lounges',
  'heathrow-airport-lounges': 'Heathrow airport lounges',
  'humberside-airport-lounges': 'Humberside airport lounges',
  'inverness-airport-lounges': 'Inverness airport lounges',
  'leeds-bradford-airport-lounges': 'Leeds Bradford airport lounges',
  'liverpool-airport-lounges': 'Liverpool airport lounges',
  'luton-airport-lounges': 'Luton airport lounges',
  'manchester-airport-lounges': 'Manchester airport lounges',
  'newcastle-airport-lounges': 'Newcastle airport lounges',
  'plymouth-airport-lounges': 'Plymouth airport lounges',
  'stansted-airport-lounges': 'Stansted airport lounges'
}

module.exports = loungeLocationPages



// WEBPACK FOOTER //
// ./shared/config/loungeLocationPages.js